<p>
  handle-action works!
</p>
